export default class UrlHandler {
  site = {};

  constructor(site) {
    this.site = site;

    this.homeUrl = `${this.site.SiteUrl}/${this.site.AdiLocale}`;
    this.feedbackUrl = `${this.site.ApiUrl}/feedback/${this.site.AdiLocale}`;

    this.companyUrl = `${this.homeUrl}/company.html`;
    this.productsUrl = `${this.homeUrl}/products.html`;
    this.applicationsUrl = `${this.homeUrl}/applications.html`;
    this.designCenterUrl = `${this.homeUrl}/design-center.html`;
    this.educationUrl = `${this.homeUrl}/education.html`;
    this.supportUrl = `${this.homeUrl}/support.html`;
    this.privacyUrl = `${this.homeUrl}/about-adi/landing-pages/001/privacy_security_statement.html`;

    this.toolUrls = {
      PrecisionStudioUrl: this.site.PrecisionStudioUrl,
      FilterWizardUrl: this.site.FilterWizardUrl,
      AdcDriverUrl: this.site.AdcDriverUrl,
      DACErrorCalculatorUrl: this.site.DACErrorCalculatorUrl,
      PhotodiodeUrl: this.site.PhotodiodeUrl,
      DiamondUrl: this.site.DiamondUrl,
      SimDDSUrl: this.site.SimddsUrl,
      SignalChainDesignerUrl: this.site.SignalChainDesignerUrl,
      VirtualEvalUrl: this.site.VirtEvalUrl,
    };

    this.siteMapUrl = `${this.site.SiteUrl}/${this.site.AdiLocale}/sitemap.html`;
    this.privacySecurityUrl = `${this.site.SiteUrl}/${this.site.AdiLocale}/about-adi/landing-pages/001/privacy_security_statement.html`;
    this.privacySettingsUrl = `${this.site.SiteUrl}/${this.site.AdiLocale}/landing-pages/001/privacy-settings.html`;
    this.termsOfUseUrl = `${this.site.SiteUrl}/${this.site.AdiLocale}/about-adi/landing-pages/001/terms_of_use.html`;
    this.chromeDownloadUrl = `http://www.google.cn/intl/${this.site.AdiLocale}/chrome/`;
    this.firefoxDownloadUrl = `https://www.mozilla.org/${this.site.AdiLocale}/firefox/new/`;
    this.technicalArticles = {
      calibrateSignalChain: `https://www.analog.com/${this.site.AdiLocale}/technical-articles/how-to-successfully-calibrate-an-open-loop-dac-signal-chain.html`,
    };
  }
}
